export const socialMediaData = [
    {
        id: 1,
        title: 'Increase brand awareness',
        message: "You can connect and communicate with your current and potential customers directly through social media platforms like Facebook, Instagram, or Twitter, where more than half of the world's population uses social media.",
        image: require('../images/megaphone marketing.svg').default,
        image_name: 'brand_awareness'
    },
    {
        id: 2,
        title: 'Boost sales',
        message: "Social media platforms are essential component of your sales funnel as the number of people using social media continues to grow and social sales tools evolve, social networks will become increasingly important for your product search and e-commerce.",
        image: require('../images/Shopping sale online.svg').default,
        image_name: 'boost_sales'
    },
    {
        id: 3,
        title: 'Drive Traffic',
        message: "Social media is a top channel for boosting traffic to your website where you can turn visitors into customers, thanks to the link in your profile, blog post links in your posts, and your advertisement. ",
        image: require('../images/Laptop at workplace showing growth chart.svg').default,
        image_name: 'drive_traffic'
    },
    {
        id: 4,
        title: 'Humanize your business',
        message: "Your audience can become familiar and comfortable with you through your profile, posts, and interactions. This strategy will make it easier for potential customers to identify your brand's products and appreciate the value you provide.",
        image: require('../images/Target with dart, user icons and social networks.svg').default,
        image_name: 'humanize_business'
    },
];